// import './wdyr';
import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import DateFnsUtils from '@date-io/date-fns';
import { FullScreenSpinner, PrivateRoute, Snackbar } from '@guryou/html-components';
import { dealTheme } from '@guryou/html-theme';
import CssBaseline from '@material-ui/core/CssBaseline';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import ForgotPassword from 'containers/ForgotPassword';
import Login from 'containers/Login';
import ReactivateAccount from 'containers/ReactivateAccount';
import ResendSignUp from 'containers/ResendSignUp';
import ResetPassword from 'containers/ResetPassword';
import VerifyPassword from 'containers/VerifyPassword';
import useUnreadMessages from 'hooks/useUnreadMessages';
import PublicProfile from 'modules/providers/containers/PublicProfile';
import Reservations from 'modules/providers/containers/Reservations';

import useFirebaseAuthBridge from './firebase/useFirebaseAuthBridge';
import Modules from './modules';
import Onboard from './onboard';

// test, retrig now

const App = () => {
  // Ativa as notificações globais em toda a aplicação , added
  useUnreadMessages();
  // .kiro/specs/1600-cognito-firestore-auth — keeps the Firebase Auth session
  // in sync with the Cognito session (sign in after login, out after logout)
  useFirebaseAuthBridge();

  return (
    <Suspense fallback={<FullScreenSpinner big />}>
      <ThemeProvider theme={createTheme(dealTheme)}>
        <CssBaseline />
        <Snackbar maxSnack={2}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Router>
              <Switch>
                <Route path="/reset/:email/:code" component={ResetPassword} />
                <Route path="/verify/:email/:code" component={VerifyPassword} />
                <Route path="/reactivate/:email/:code" component={ReactivateAccount} />
                <Route exact path="/forgot-password" component={ForgotPassword} />
                <Route exact path="/resend-code" component={ResendSignUp} />
                <Route path="/login" component={Login} />
                <Route path="/reservations" component={Reservations} />
                <Route path="/publicProfile" component={PublicProfile} />
                <PrivateRoute path="/onboard" component={Onboard} />
                <PrivateRoute path="/" component={Modules} saveRegion={true} />
              </Switch>
            </Router>
          </MuiPickersUtilsProvider>
        </Snackbar>
      </ThemeProvider>
    </Suspense>
  );
};
export default App;
